import {configureStore} from '@reduxjs/toolkit'
import userReducer from '../Features/userSlice'
import workoutReducer from '../Features/workoutSlice'
import dietReducer from "../Features/DietSlice"

const store = configureStore({
    reducer : {
        user : userReducer,
        workout : workoutReducer,
        diet : dietReducer
    }
})


export default store